<template xmlns:v-on="http://www.w3.org/1999/xhtml">
  <div>
    <headlink v-if="parent == '0'"></headlink>
    <headlink1 v-if="parent == '1'"></headlink1>
    
  
        	
<div >
	

       <li v-for="item of eqlist">
             {{item.eqId}}
           </li>
    
</div>
 
    
 
    
    
    
    
    

  
     
     
     
        
	    
			
  </div>

</template>

<script>
   import headlink from '@/components/common/headlink'
	import headlink1 from '@/components/common/headlink1'
	import devicemanage1 from '@/components/devicemanage/devicemanage1'
	import devicemanage2 from '@/components/devicemanage/devicemanage2'

  export default {
    name: 'shuju',
    data () {
      return {
        eqlist:[],
        shuju:{},
        parent: "0"
        
      }
    },
     methods: {
     	 initWebsocketa: function () {
      	
    
	var socketURL = "ws://"+"localhost:8080/ZYun" + "/websocket";
	var socket;
	socket = new WebSocket(socketURL);
         console.log(socket);
         
       
	socket.onopen = function() {

        const history = window.sessionStorage;

		var mobile=history.getItem("mobile");
	   var params = {
		code : '1002',
		user : mobile
	}
       if (socket) {
		
		var message = JSON.stringify(params);
		 socket.send(message);
	}else{
		 alert("websocket is closed!");

	}
       
       
       
       
       
//    this.$options.methods.logon();
	};

	socket.onmessage = function(evt) {
		// 收到消息回调
//	this.$options.methods.messageCallback(evt.data);
//		          messageCallback(evt.data);
     

     if (evt.data != "X") {
		 
		var json = JSON.parse(evt.data);
		var code = json["code"];
		var eqname=json["eqname"];
		var eqid=json["eqid"];
		var context=json["context"];
		if (code=="ok") {
       
			
			  $("#"+eqid).find("div[data-id='"+dataId+"']").find("span[class='data-value']").html(dataValue);
			
			   
	} 
	}



	};

	socket.onclose = function(event) {
		mylog("WS is closed. " + event);
		socket = undefined;
		 this.$options.methods.initWebsocket();
	};

	socket.onerror = function(event) {
		mylog("WS is error. " + event.data);
		socket = undefined;
	};
},
   },
		 mounted:function(){
		 	 this.initWebsocketa();
	   const history = window.sessionStorage;
	   
	     var uid = history.getItem("user");
//	       var params = {
//		       serviceCode : '1036',
//		       uId : uid
//	       }
	 function getdata() {
        var json = {
						"serviceCode": "1036",
						"uId": uid
					}
					return json;
				}
	 
	 
	 
	 
	 $.ajax({
		type:"post",
		url:"http://localhost:8080/ZYun/HttpService.do",
		async:true,
		dataType:'json',
		data:JSON.stringify(getdata()),
		success:function(datat){
			console.log(datat);
			if(datat.respCode=='0000'){
				console.log("标记位");
			 this.eqlist=datat.eqList;
			 var a=new Array();
		 $.each(datat.eqList, function(index,eq) {
		  	
		  	  console.log(eq);
		  	$.each(eq.datas, function(index,shuju) {
		  		a.push(shuju);
		  		this.shuju=a;
		  	})
	 })
		   
			}
		}
	})

 	
		 	
		 	
		 	
		 },
    components: {
       headlink: headlink,
			headlink1: headlink1,
			devicemanage1: devicemanage1,
			devicemanage2: devicemanage2
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="../../../static/css/index.css" >
</style>



// WEBPACK FOOTER //
// src/components/devicemanage/shuju.vue